<template>
  <SubContent h="550px" @back="toCancel">
    <template v-slot:nav_left> 添加赛事督导 </template>
    <div class="page-content">
      <div class="form_wrap">
        <vue-scroll>
          <div class="scroll-content form-content">
            <el-form
              :inline="false"
              ref="form"
              :model="form"
              :rules="formRules"
              label-width="105px"
            >
              <fieldset class="vita-form-fieldset">
                <legend style="margin-left:20px">单位信息</legend>
                <el-row>
                  <el-col :span="12">
                    <el-form-item  label="管理协会" prop="organShortName" :rules="[{ required: true, message: '必填项' }]">
                      <el-input v-model="form.organShortName" class="w280" disabled></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="单位"  prop="youthShortName" :rules="[{ required: true, message: '必填项' }]">
                      <el-input v-model="form.youthShortName" class="w280" disabled></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <template v-if="form.matchName !== '其他'">
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="比赛名称" prop="matchName" :rules="[{ required: true, message: '必填项'}]">
                        <!--<el-input v-model="form.matchName" class="w280" placeholder="请输入比赛名称" maxlength="80" show-word-limit></el-input>-->
                        <el-select v-model="form.matchName" filterable style="width:100%" placeholder="选择比赛">
                          <el-option v-for="(item,index) in matchNameList" :key="index" :label="item" :value="item"/>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </template>
                <template v-else>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="比赛名称" prop="matchName" :rules="[{ required: true, message: '必填项'}]">
                        <!--<el-input v-model="form.matchName" class="w280" placeholder="请输入比赛名称" maxlength="80" show-word-limit></el-input>-->
                        <el-select v-model="form.matchName" filterable class="w280" placeholder="选择比赛">
                          <el-option v-for="(item,index) in matchNameList" :key="index" :label="item" :value="item"/>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="输入名称" prop="matchOtherName" :rules="[{ required: true, message: '必填项'}]">
                        <el-input v-model="form.matchOtherName" class="w280" placeholder="请输入比赛名称" maxlength="80" show-word-limit></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </template>

                <el-row>
                  <el-col :span="12">
                    <el-form-item label="比赛时间" prop="matchTime" :rules="[{ required: true, message: '必填项',trigger: 'change' }]">
                      <el-date-picker v-model="form.matchTime" class="w280" align="right" type="date" value-format="timestamp" placeholder="选择日期"></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="赛区名称" prop="matchTitle" :rules="[{ required: true, message: '必填项'}]">
                      <el-input v-model="form.matchTitle" class="w280" placeholder="请输入赛区名称" maxlength="80" show-word-limit></el-input>
                    </el-form-item>
                  </el-col>


                </el-row>

                <el-row>
                  <el-col :span="12">
                    <el-form-item label="组别" prop="matchGroup" :rules="[{ required: true, message: '必填项',trigger: 'blur' }]">
                      <el-input v-model="form.matchGroup" class="w280" placeholder="请输入组别" maxlength="80" show-word-limit></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="球队名称" prop="squadName" :rules="[{ required: true, message: '必填项',trigger: 'blur' }]">
                      <el-input v-model="form.squadName" class="w280" placeholder="请输入球队名称" maxlength="80" show-word-limit></el-input>
                    </el-form-item>
                  </el-col>

                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="教练员" prop="coachUuid" :rules="[{ required: false, message: '必填项',trigger: 'change' }]">
                      <el-select v-model="form.coachUuid" filterable multiple class="w280" placeholder="选择教练员">
                        <el-option v-for="(item,index) in coachesList" :key="index" :label="item.idName" :value="item.uuid"/>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="总分：">
                      <span style="font-size:20px;font-weight:bold">{{totalScore || '--'}}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="备注">
                      <el-input v-model.trim="form.otherCoach" style="width:100%" placeholder="例如教练员名单不在系统内无法选择，可以在此处手动填写教练员姓名" maxlength="80" show-word-limit></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </fieldset>
              <fieldset class="vita-form-fieldset">
                <legend style="margin-left:20px">球队管理(40分)</legend>
                <el-row class="scoreSilder">
                  <el-col :span="11">
                    <el-form-item label="重视程度(10分)" label-width="135px" prop="squadDegreeAttention" :rules="[{ required: true, message: '必填项',trigger: 'change' }]">
                      <el-slider v-model.number="form.squadDegreeAttention" :min='0' :max="10" show-input></el-slider>
                    </el-form-item>
                  </el-col>
                  <el-col :span="11">
                    <el-form-item label="赛风赛纪(10分)" label-width="135px" prop="squadDiscipline" :rules="[{ required: true, message: '必填项',trigger: 'change' }]">
                      <el-slider v-model.number="form.squadDiscipline" :min='0' :max="10" show-input></el-slider>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row class="scoreSilder">
                  <el-col :span="11">
                    <el-form-item label="按时到达(10分)" label-width="135px" prop="squadArrive" :rules="[{ required: true, message: '必填项',trigger: 'change' }]">
                      <el-slider v-model.number="form.squadArrive" :min='0' :max="10" show-input></el-slider>
                    </el-form-item>
                  </el-col>
                  <el-col :span="11">
                    <el-form-item label="服装统一(10分)" label-width="135px" prop="squadUniformCostumes" :rules="[{ required: true, message: '必填项',trigger: 'change' }]">
                      <el-slider v-model.number="form.squadUniformCostumes" :min='0' :max="10" show-input></el-slider>
                    </el-form-item>
                  </el-col>
                </el-row>
              </fieldset>

              <fieldset class="vita-form-fieldset">
                <legend style="margin-left:20px">执教能力(60分)</legend>
                <el-row class="scoreSilder">
                  <el-col :span="11">
                    <el-form-item label="战术安排(15分)" label-width="135px" prop="coachTactics" :rules="[{ required: true, message: '必填项',trigger: 'change' }]">
                      <el-slider v-model.number="form.coachTactics" :min='0' :max="15" show-input></el-slider>
                    </el-form-item>
                  </el-col>
                  <el-col :span="11">
                    <el-form-item label="观察指导(15分)" label-width="135px" prop="coachObservational" :rules="[{ required: true, message: '必填项',trigger: 'change' }]">
                      <el-slider v-model.number="form.coachObservational" :min='0' :max="15" show-input></el-slider>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row class="scoreSilder">
                  <el-col :span="11">
                    <el-form-item label="应变调整(15分)" label-width="135px" prop="coachStrainAdjustment" :rules="[{ required: true, message: '必填项',trigger: 'change' }]">
                      <el-slider v-model.number="form.coachStrainAdjustment" :min='0' :max="15" show-input></el-slider>
                    </el-form-item>
                  </el-col>
                  <el-col :span="11">
                    <el-form-item label="队员技术(15分)" label-width="135px" prop="coachPlayerTactics" :rules="[{ required: true, message: '必填项',trigger: 'change' }]">
                      <el-slider v-model.number="form.coachPlayerTactics" :min='0' :max="15" show-input></el-slider>
                    </el-form-item>
                  </el-col>
                </el-row>
              </fieldset>
              <fieldset class="vita-form-fieldset longTitle">
                <!--<legend style="margin-left:20px">机构现状</legend>-->
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="执教现状分析及存在的问题" label-width="135px" prop="coachBaseStatus" :rules="[{ required: true, message: '必填项' }]">
                      <el-input v-model="form.coachBaseStatus" class="w480" type="textarea" :rows="2" placeholder="请输入执教现状分析及存在的问题" maxlength="200" show-word-limit></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="执教工作亮点及值得推广的措施" label-width="135px" prop="workHighlights" :rules="[{ required: true, message: '必填项' }]">
                      <el-input v-model="form.workHighlights" class="w480" type="textarea" :rows="2" placeholder="请输入执教工作亮点及值得推广的措施" maxlength="200" show-word-limit></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="问题及建议" label-width="135px" prop="questionsSuggestions" :rules="[{ required: true, message: '必填项' }]">
                      <el-input v-model="form.questionsSuggestions" class="w480" type="textarea" :rows="2" placeholder="请输入问题及建议" maxlength="200" show-word-limit></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </fieldset>

              <el-row>
                <el-col :span="24">
                  <el-form-item label="签字人（可多选）" label-width="165px" prop="supervisorySignatoriesUuids" :rules="[{ required: false, message: '必填项',trigger: 'change' }]">
                    <el-select v-model="form.supervisorySignatoriesUuids" filterable multiple style="width:463px" placeholder="选择签字人">
                      <el-option v-for="(item,index) in supervisoryList" :key="index" :label="item.supervisoryName" :value="item.supervisoryUuid"/>
                    </el-select>
                  </el-form-item>
                </el-col>
                <span style="color:#f88594">注：添加签字人信息后将生成本报告的最终版本，提交后将无法修改。</span>
              </el-row>


            </el-form>
          </div>
        </vue-scroll>
        <yioks-tips
          :showTip="tipsFlag"
          :tipMsg="form.supervisorySignatoriesUuids.length ? '添加签字人信息后将生成本报告的最终版本，提交后将无法修改，请确认是否提交？' : '请确认保存并退出？'"
          :loading="repeatSubmit"
          @callback="hideTipsDialog"
        ></yioks-tips>
        <yioks-tips
          :showTip="tipsFlagCancel"
          tipMsg="请确认放弃保存并返回吗？"
          :loading="repeatSubmitCancel"
          @callback="hideTipsDialogCancel"
        ></yioks-tips>
      </div>
    </div>

    <template v-slot:btn>
      <div class="btn_wrap">
        <el-button type="primary" @click="tempSave">保存</el-button>
        <el-button type="danger" @click="toCancel">取消</el-button>
      </div>
    </template>
  </SubContent>
</template>

<script>
  import scout from "@/api/scout";
  import supervision from "@/api/supervision";
  import center from "@/api/center";
  import squad from "@/api/squad";
  import storage from "@/utils/storage";
  import {filterIdNumber} from "@/utils/yioks_filter";
  import { squadSexList,matchNameList } from '@/utils/yioks_data'

  export default {
  name: "ScoutList",

  data() {
    return {
      squadSexList,
      matchNameList,
      tipsFlag: false,
      repeatSubmit: false,
      tipsFlagCancel: false,
      repeatSubmitCancel: false,
      repeatNext: false,
      tipsFlagNext: false,
      userRole: storage.get("userInfo").userRole,
      uuid: storage.get("userInfo").uuid,
      activeStep: 1,
      coachesList:[],
      supervisoryList:[],
      form: {
        organUuid:'',
        youthUuid:'',
        squadUuid:'',
        organShortName:'',
        youthShortName:'',
        shortName:'',
        writeTime:new Date().getTime(),// 填写时间
        matchTime:'',// 时间
        matchTitle:'',// 赛区名称
        matchName:'',// 比赛名称
        matchOtherName:'',
        coachUuid:[],// 教练员Uuid
        otherCoach:'',// 其他教练员
        matchGroup:'',// 组别
        squadName:'',// 球队
        trainCoach:'',// 教练员
        totalScore:'',// 总分
        squadDegreeAttention:0,// 球队重视程度
        squadDiscipline:0,// 球队赛风赛纪
        squadArrive:0,// 球队按时到达
        squadUniformCostumes:0,// 球队服装统一
        coachTactics:0,// 执教 战术
        coachObservational:0,// 执教 观察指导
        coachStrainAdjustment:0,// 执教 应变调整
        coachPlayerTactics:0,// 执教 队员技术
        coachBaseStatus:'',// 执教现状及问题分析
        workHighlights:'',// 执教工作亮点及值得推广的措施
        questionsSuggestions:'',// 反馈建议
        supervisorySignatories:'',// 签字人
        supervisorySignatoriesUuids:[],// 签字人
      },
      formRules: {
      },
    };
  },

  components: {
    SubContent: () => import("@/components/layout/contentWithbtn"),
    "yioks-tips": () => import("@/components/YioksTip"),
  },

  computed: {
    organUuid() {
      return this.$route.query.organUuid || "";
    },
    youthUuid() {
      return this.$route.query.youthUuid || "";
    },
    totalScore() {
      const scores = [
        this.form.coachTactics,
        this.form.coachObservational,
        this.form.coachStrainAdjustment,
        this.form.coachPlayerTactics,
        this.form.squadDegreeAttention,
        this.form.squadDiscipline,
        this.form.squadArrive,
        this.form.squadUniformCostumes
      ];
      return scores.reduce((sum, score) => sum + score, 0);
    },
  },

  created() {
    // 请求一下球队的相关信息
    this.loadCenterInfo();
    this.getSupervisoryPersonList();
  },

  mounted() {
  },

  methods: {
    /* 暂时保存 */
    tempSave(status) {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.tipsFlag = true;
        }else {
          this.$message.error("请完善所有带 * 的必填项");
        }
      });
    },
    /* 暂时保存 */
    hideTipsDialog(ok) {
      if (ok) {
        if(this.form.coachUuid.length===0 && !this.form.otherCoach){
          this.$message.error("教练员未添加");
          return
        }
        if (!this.repeatSubmit) {
          this.repeatSubmit = true;
          this.$refs["form"].validate((valid) => {
            if (valid) {
              let coachNames = [];
              this.form.coachUuid.map(ite=>{
                let coachName = this.coachesList.find((item) => {
                  return item.uuid === ite;
                }).idName
                coachNames.push(coachName);
              });

              let supervisoryNames = [];
              this.form.supervisorySignatoriesUuids.map(ite=>{
                let supervisoryName = this.supervisoryList.find((item) => {
                  return item.supervisoryUuid === ite;
                }).supervisoryName
                supervisoryNames.push(supervisoryName);
              });

              const {coachUuid,supervisorySignatoriesUuids,...rest } = this.form;
              let name = this.form.matchName;
              if(this.form.matchName==='其他'){
                name = this.form.matchOtherName;
              }
              let aimData = {
                ...rest,
                matchName:name,
                totalScore : this.totalScore,
                coachUuid : coachUuid.join(","),
                trainCoach : coachNames.join(","),
                supervisorySignatoriesUuids : supervisorySignatoriesUuids ? supervisorySignatoriesUuids.join(",") : '',
                supervisorySignatories : supervisoryNames ? supervisoryNames.join(",") : '',
              };
              supervision.addMatchSupervisory(aimData).then((res) => {
                this.repeatSubmit = false;
                this.tipsFlag = false;
                if (res.code) {
                  this.$message.error(res.msg);
                } else {
                  this.$router.go(-1);
                }
              })
              .catch((err) => {
                this.repeatSubmit = false;
                this.tipsFlag = false;
                console.log(err);
              });
            }
          });
        }
      } else {
        this.repeatSubmit = false;
        this.tipsFlag = false;
      }
    },
    /* 取消 */
    toCancel() {
      this.tipsFlagCancel = true;
    },
    hideTipsDialogCancel(ok) {
      if (ok) {
        this.repeatSubmitCancel = false;
        this.tipsFlagCancel = false;
        this.$router.go(-1);
      } else {
        this.repeatSubmitCancel = false;
        this.tipsFlagCancel = false;
      }
    },

    /* 获取信息 */
    loadCenterInfo() {
      center.getCenterInfo(this.youthUuid).then((res) => {
          this.$set(this.form, "youthUuid", this.youthUuid);
          this.$set(this.form, "youthShortName",  res.youth.youthShortName);
          this.$set(this.form, "organUuid",  res.youth.organUuid);
          this.$set(this.form, "organShortName", res.youth.organShortName);
          this.coachesList = res.coachInfoVos
        })
        .catch((err) => {
          console.error("请求异常", err);
        });
    },
    getSupervisoryPersonList() {
      supervision.supervisoryPersonList().then((res) => {
        if (res.code) {
          this.$message.error(res.msg);
          return
        }
        this.supervisoryList = res
      })
      .catch((err) => {
        console.error("请求异常", err);
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.form_wrap
  padding 20px
  overflow hidden
  box-sizing border-box
  flex 1
  font-size 16px
  height 554px
  .vita-form-fieldset
    margin: 0 0 20px 0;
    padding: 10px 10px 0;
    border: 1px dashed $color_white;
    width: 97%
    .scoreSilder
      display: flex;
      align-items: center;
      justify-content: space-between;
.step-box
  margin-top 10px
.btn_wrap
  width 100%
  display flex
  justify-content center
.w380
  width 300px
.w280
  width 300px
.w480
  width 480px
.w150
  width 160px
.player-list-wrapper
  width 95%
  display flex
  justify-content space-around
  border-bottom 1px dashed #ccc
  border-top 1px dashed #ccc
  padding 20px 20px 0px 0px
  margin-bottom 20px
  .left-box
    width 100%
  .right-box
    width 40px
    display flex
    justify-content center
    flex-direction column
    align-items center
</style>

<style lang="stylus">
.page-content
  .el-steps--simple
    background-color rgba(0, 0, 0, 0)
  .el-form-item__label
    color #fff
    font-size 16px
</style>
<style lang="stylus">
@import '~@/assets/css/variable'
.yioks-switch
  .el-switch__label
    color $color_white
  .el-switch__label--left
    &.is-active
      color $color_white
  .el-switch__label--right
    &.is-active
      color $green_color
.yioks-switch-grey
  .el-switch__label
    color $grey_color
  .el-switch__label--left
    &.is-active
      color $grey_color
  .el-switch__label--right
    &.is-active
      color $green_color
.el-radio
  color: white
input[aria-hidden=true] {
  display: none !important;
}
.el-slider__input
  width 100px
.el-slider__runway.show-input
  margin-top: 16px;
  width: 50%;
.longTitle
  label
    line-height: 23px
</style>
